<div class="dialog-container">
  <div class="dialog-header">
    <h1 class="dialog-title">Cancel test</h1>
    <button mat-icon-button (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <p class="dialog-message">Are you sure you want to cancel this test?</p>
  <label class="label">REASON FOR CANCELLATION:</label>
  <mat-form-field appearance="none">
    <textarea maxlength="200" class="comments" matInput [(ngModel)]="reason" placeholder="e.g., Weather conditions, schedule change..."></textarea>
  </mat-form-field>
  <div class="cancel-dialog-actions">
    <app-secondary-button (handleClick)="cancel()">No</app-secondary-button>
    <app-primary-button (handleClick)="confirm()">Continue</app-primary-button>
  </div>
</div>
